import React from 'react';

const NavLeftIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24px"
      height="24px"
      viewBox="0 0 24 24"
      version="1.1"
    >
      <g
        id="icons/24/caret-left"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <polyline
          id="Path"
          stroke="#F2F5F8"
          transform="translate(15.250000, 12.250000) rotate(-225.000000) translate(-15.250000, -12.250000) "
          points="21.5 6 21.5 18.5 9 18.5"
        />
      </g>
    </svg>
  );
};

export default NavLeftIcon;
